import * as React from 'react';
import { ResponseStatuses } from '../EditContact';
import { Box, SectionHelper, TextButton, FloatingNotification, Text, } from 'wix-style-react';
import { translate, Trans } from 'react-i18next';
import { EditContactEvent, } from '../../../constants/events';
import ExternalLink from 'wix-ui-icons-common/dist/src/general/dist/components/ExternalLink';
import * as style from './Notifications.scss';
var Notifications = function (_a) {
    var t = _a.t, responseStatus = _a.responseStatus, responseOptions = _a.responseOptions, onClose = _a.onClose, log = _a.log;
    var onDuplicateContactLinkClick = function (contactId, contactUrl) {
        log(EditContactEvent.CLICK_VIEW_CONTACT, {
            contactId: contactId,
        });
        window.open(contactUrl);
    };
    var renderDuplicatedWarning = function () {
        return (React.createElement(Box, { marginBottom: "18px" },
            React.createElement(SectionHelper, { dataHook: "warning-bar", appearance: "warning", onClose: onClose, title: t('editContact.errorBar.duplicatedWarning.title') },
                React.createElement(Trans, { defaults: t('editContact.errorBar.duplicatedWarning.body', {
                        email: responseOptions.contactInfo.email,
                    }), components: [
                        React.createElement("br", { key: 0 }),
                        React.createElement(TextButton, { as: "a", underline: "always", size: "small", dataHook: "view-contact-link", key: 1, skin: "dark", onClick: function () {
                                return onDuplicateContactLinkClick(responseOptions.contactInfo.contactId, responseOptions.contactInfo.contactUrl);
                            } }, "I will be replaced by the I18n script."),
                        React.createElement(ExternalLink, { size: "20px", key: 2, className: style.duplicateLinkIcon, onClick: function () {
                                return onDuplicateContactLinkClick(responseOptions.contactInfo.contactId, responseOptions.contactInfo.contactUrl);
                            } }),
                    ] }))));
    };
    var renderSuccess = function () {
        return (React.createElement(Box, { marginBottom: "18px" },
            React.createElement(FloatingNotification, { type: "success", onClose: onClose, width: "100%", text: React.createElement(Box, { paddingTop: "3px" },
                    React.createElement(Text, { size: "small", dataHook: "succecss-bar-text" }, t('editContact.notificationBar.createAnother.body')),
                    "\u00A0",
                    React.createElement(TextButton, { dataHook: "success-view-contact-btn", size: "small", skin: "dark", underline: "always", onClick: function () {
                            return window.open(responseOptions.contactInfo.contactUrl);
                        } }, t('editContact.notificationBar.createAnother.link')),
                    React.createElement(ExternalLink, { size: "20px", className: style.linkIcon, onClick: function () {
                            return window.open(responseOptions.contactInfo.contactUrl);
                        } })) })));
    };
    var renderError = function () {
        var key = responseStatus === ResponseStatuses.EMPTY_REQUIRED_FIELDS_ERROR
            ? 'editContact.errorBar.emptyRequiredFields'
            : 'editContact.errorBar.unknownError';
        return (React.createElement(Box, { marginBottom: "18px" },
            React.createElement(FloatingNotification, { dataHook: "error-bar", showCloseButton: false, type: "destructive", text: t(key), width: "100%" })));
    };
    var Errors = [
        ResponseStatuses.EMPTY_REQUIRED_FIELDS_ERROR,
        ResponseStatuses.UNKNOWN_ERROR,
    ];
    return (React.createElement("div", { "data-hook": "notifications-bar" }, Errors.includes(responseStatus)
        ? renderError()
        : responseStatus === ResponseStatuses.DUPLICATE_WARNING
            ? renderDuplicatedWarning()
            : responseStatus === ResponseStatuses.SUCCESS_CREATE_ANOTHER
                ? renderSuccess()
                : null));
};
export default translate()(Notifications);
//# sourceMappingURL=Notifications.js.map